// extracted by mini-css-extract-plugin
module.exports = {"sign_up_widget":"SignUpWidget_sign_up_widget__Ln474","text":"SignUpWidget_text__IACYb","button":"SignUpWidget_button__Eoi6k"};